import { Action, createStore } from "redux";
import rootred from "../reducers/main";
import { configureStore, ThunkAction } from "@reduxjs/toolkit";
import rootReducer from "../reducers/main";

const store = configureStore({
    reducer: rootReducer,
    middleware: getDefaultMiddleware => {
        return getDefaultMiddleware({
            serializableCheck: false
        })
    }
})

export { store }
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType,
    RootState,
    unknown,
    Action<string>>;
